import { Outlet } from "react-router-dom";
import Sidebar from "@/components/nav/Sidebar";
import Topbar from "@/components/nav/Topbar";
import AccountBanners from "@/components/AccountBanners";
import WhatsAppAlerts from "@/features/whatsapp/alerts";

export default function AppLayout() {
  return (
    <div className="flex h-svh w-full bg-background">
      <WhatsAppAlerts />
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-y-auto">
          <div className="mx-auto w-full max-w-7xl p-4 md:p-6 lg:p-8">
            <AccountBanners />
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
